import { Input, Select, DatePicker, TimePicker } from "antd";
import styled, { CSSProperties } from "styled-components";
import { ReactElement, KeyboardEvent } from "react";
import { IHandleBlur, IHandleChange, ILimitDate, ISelect } from "@interfaces";

const { Option } = Select;
interface IProps {
  name?: string;
  label?: string | JSX.Element;
  descLabel?: string;
  value?: string | number;
  className?: string;
  style?: CSSProperties | undefined;
  styleParent?: CSSProperties | undefined;
  onChange?: IHandleChange;
  onBlur?: IHandleBlur;
  onClick?: () => void;
  type?: string;
  prefixIcon?: ReactElement;
  suffixIcon?: ReactElement;
  notFormik?: boolean;
  placeholder?: string;
  notErr?: boolean;
  disable?: boolean;
  errors?: string | undefined;
  touched?: boolean | undefined;
  defaultValue?: string | number;
  parentClassName?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  ref?: any;
}

export const SharedInput = (props: IProps) => {
  //page props
  const {
    name,
    style,
    onChange,
    onBlur,
    onClick,
    value,
    type,
    prefixIcon,
    suffixIcon,
    // notFormik,
    placeholder,
    className,
    notErr,
    disable,
    errors,
    touched,
    label,
    descLabel,
    styleParent,
    defaultValue,
    parentClassName,
    onKeyDown,
    ref,
  } = props;

  return (
    <StyledContainer className={parentClassName} style={styleParent}>
      {label && (
        <label htmlFor={name} className="label">
          <span className="label-name">{label}</span>
          <span>{descLabel}</span>
        </label>
      )}
      <Input
        ref={ref}
        onKeyDown={onKeyDown}
        id={name}
        className={errors && touched ? `${className} input-invalid` : className}
        type={type}
        name={name}
        value={value}
        style={{ ...style }}
        onChange={onChange}
        onWheel={(event) => event.currentTarget.blur()} // prevent scrolling change number
        onBlur={onBlur}
        onClick={onClick}
        prefix={prefixIcon}
        suffix={suffixIcon}
        placeholder={placeholder}
        disabled={disable}
        defaultValue={defaultValue}
      />
    </StyledContainer>
  );
};
styled;
const StyledContainer = styled.div``;
